import { DropDownLabelValue } from '@/app/ui/components/DropdownSelect/interface'
import { PickupCorporateSearchFieldOption, PickupCorporateSpecialHandlingFilterFlag } from '../PickupCorporateFilter/index.types'

// Option Dropdown Cari
export const SEARCH_FIELD_OPTIONS: PickupCorporateSearchFieldOption[] = [
  { label: 'Shipment ID', value: 'order_id' },
  { label: 'Nama customer', value: 'customer_name' },
  { label: 'Nama client', value: 'client_name' },
  { label: 'Client ID', value: 'client_id' },
  { label: 'Nama kurir terakhir', value: 'latest_courier' },
  { label: 'No. handphone', value: 'phone_number' }
]

// Option Estimasi Waktu Pick Up
export const ESTIMATE_PICKUP_TIME_OPTIONS: DropDownLabelValue<string>[] = [
  { label: '>3 jam lagi', value: 'three_hours_left' },
  { label: '1-2 jam lagi', value: 'two_hours_left' },
  { label: '0-1 jam lagi', value: 'one_hour_left' },
  { label: 'Terlambat 0-1 jam', value: 'late_one_hour' },
  { label: 'Terlambat 1-2 jam', value: 'late_two_hours' },
  { label: 'Terlambat >3 jam', value: 'late_over_three_hours' }
]

// Option Origin Country (Pilih negara)
export const ORIGIN_COUNTRY_OPTIONS: DropDownLabelValue<string>[] = [
  { label: 'Indonesia', value: 'Indonesia' },
  { label: 'Malaysia', value: 'Malaysia' }
]

// Option Special Handling (DG, K, KAYU)
export const SPECIAL_HANDLING_OPTIONS: DropDownLabelValue<string>[] = [
  { label: 'Dangerous goods', value: 'dangerous_goods' },
  { label: 'Karantina', value: 'quarantine' },
  { label: 'Packing Kayu', value: 'wood_packing' }
]

export const CANCEL_REASON_OPTIONS: DropDownLabelValue<string>[] = [
  {
    label: '-',
    value: '-',
  },
  {
    label: 'Customer Ingin Mengubah Jadwal Pickup/Pengantaran',
    value: 'PAGLH',
  },
  {
    label: 'Customer Sulit Dihubungi',
    value: 'CSTSD',
  },
  {
    label: 'Customer Tidak Berada di Lokasi',
    value: 'PNTDA',
  },
  {
    label: 'Sudah Melewati Batas Waktu Pickup',
    value: 'SMBWP',
  },
  {
    label: 'Toko Tutup',
    value: 'TKTP',
  },
  {
    label: 'Produk Pesanan Tidak Tersedia/habis',
    value: 'PPTT',
  },
  {
    label: 'Paket Belum Siap di Pickup',
    value: 'BBSDP',
  },
  {
    label: 'Customer Ingin Mengubah Ekspedisi',
    value: 'CSTME',
  },
  {
    label: 'Lokasi Pickup Terlalu Jauh',
    value: 'APTLJ',
  },
  {
    label: 'Kendala Motor Atau Ponsel',
    value: 'KNRSK',
  },
  {
    label: 'Customer Dropoff ke POS/HUB Terdekat',
    value: 'DROP',
  },
  {
    label: 'Paket Diambil Kurir Lain',
    value: 'PKDKL',
  },
  {
    label: 'Alamat Tidak Ketemu',
    value: 'ALMSL',
  },
  {
    label: 'Lokasi Tutup Atau Pindah ',
    value: 'TLPST',
  },
  {
    label: 'Force Majeur',
    value: 'KLTDM',
  },
  {
    label: 'Dibatalkan oleh Admin',
    value: 'ADMIN',
  },
  {
    label: 'Lokasi Tutup',
    value: 'LKTTP',
  },
  {
    label: 'Lokasi Pindah',
    value: 'LKPDH',
  },
  {
    label: 'Kendala lainnya',
    value: 'ZZZZZ',
  },
]


/**
 * Konversi dari Array Label UI (DropdownCheckbox) -> Array Enum BE
 * Contoh: ["Packing Kayu", "Karantina"] -> ["wood_packing", "quarantine"]
 */
export function mapLabelsToBEFlags(
  selectedLabels: string[]
): PickupCorporateSpecialHandlingFilterFlag[] {
  if (!selectedLabels || !Array.isArray(selectedLabels)) return []

  return selectedLabels
    .map((label) => {
      const found = SPECIAL_HANDLING_OPTIONS.find(
        (opt) => opt.label.toLowerCase() === String(label).toLowerCase()
      )
      return found ? (found.value as PickupCorporateSpecialHandlingFilterFlag) : null
    })
    .filter((v): v is PickupCorporateSpecialHandlingFilterFlag => v !== null)
}

/**
 * Konversi dari Array Enum BE -> Array Label UI (untuk prop :value DropdownCheckbox)
 * Contoh: ["wood_packing", "quarantine"] -> ["Packing Kayu", "Karantina"]
 */
export function mapBEFlagsToLabels(
  beFlags: PickupCorporateSpecialHandlingFilterFlag[]
): string[] {
  if (!beFlags || !Array.isArray(beFlags)) return []

  return beFlags
    .map((flag) => {
      const found = SPECIAL_HANDLING_OPTIONS.find((opt) => opt.value === flag)
      return found ? found.label : null
    })
    .filter((v): v is string => v !== null)
}
